/** A brandless Agent can open review for an explicit setup request. This
 * never submits website analysis or allows a normal ad request past the gate. */
export function brandSetupReviewUrl(message: string): string | undefined {
  if (!/\b(?:set\s*up|onboard|add|create|open)\b[^.!?\n]{0,90}\bbrand\b/i.test(message)) return;
  const urls = message.match(/https?:\/\/[^\s<>"']+/gi);
  if (urls?.length !== 1) return;
  try {
    const url = new URL(urls[0].replace(/[),.;!?]+$/, ''));
    if (url.username || url.password || !url.hostname.includes('.')) return;
    return url.href;
  } catch { return; }
}
